import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { createApiKey, listApiKeys, revokeApiKey } from '@/api/apikeys';

export function useApiKeys() {
  return useQuery({ queryKey: ['apikeys'], queryFn: () => listApiKeys() });
}

export function useCreateApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { name: string; scopes: string[] }) => createApiKey(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['apikeys'] }),
  });
}

export function useRevokeApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => revokeApiKey(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['apikeys'] }),
  });
}
